import React from 'react'
import ReadMore from '../ReadMore'

const Text = ({ content }) => {
  return (
    <div className="my-3 mx-2 text-gray-500 font-semibold text-md">
      <ReadMore text={content} />
    </div>
  )
}

export default Text